import { relayStylePagination } from '@apollo/client/utilities'

import type { KeyArgsFunction, KeySpecifier } from '@apollo/client/cache/inmemory/policies'
import type { Reference } from '@apollo/client/utilities'
import type { RelayFieldPolicy } from '@apollo/client/utilities/policies/pagination'

/**
 * @private only to be used in apolloClient.ts
 * see https://github.com/apollographql/apollo-client/issues/7944
 */
export const fixedRelayStylePagination = (
  keyArgs?: false | KeySpecifier | KeyArgsFunction
): RelayFieldPolicy<Reference> => {
  const { read, merge, ...rest } = relayStylePagination(keyArgs)
  return {
    ...rest,
    read: (existing, options) => {
      if (!existing?.edges) return existing
      return read!(existing, options)
    },
    // @ts-expect-error TODO: Fix properly & remove this
    merge: (existing, incoming, options) => {
      if (!incoming?.edges) return incoming

      const _existing = existing
        ? {
            ...existing,
            edges: existing.edges ?? [],
          }
        : existing
      return typeof merge === 'boolean' ? merge : merge!(_existing, incoming, options)
    },
  }
}
